import { useState } from "react";
import { AppPTORequests } from "../app-time-off/AppPTORequests";
import { AppTimeOff } from "../app-time-off/AppTimeOff";
import { AppTimeOffRequest } from "../app-time-off/AppTimeOffRequest";
import { DCBaseProps } from "./DCBase";


type DCPTORequestProps = DCBaseProps & {
    data: {
        employeeRecordIds: string[] | undefined;
    }
    balanceOnly?: boolean; // Optional prop to indicate if it's for balance only
} 

 export const DCPTORequest = ({data, isOutdated, balanceOnly = false, onNavigation}: DCPTORequestProps) => {

    console.log("[DCPTORequest] isOutdated: ", isOutdated);
    console.log("[DCPTORequest] data: ", data);

    return (
        <div className="dc-component-card">
            <AppTimeOffRequest 
                dynamicContext={{employeeRecordIds: data.employeeRecordIds}} 
                balanceOnly={balanceOnly}
                disabled={isOutdated}
                onNavigation={onNavigation}
            /> 
        </div>
    )
}
